import APIService from '../services/API';

/**
 * An IIFE service which provides a method of loading, storing, and referencing all
 *  loaded SVGs.
 * Also provides methods for drawing various SVG elements onto passed SVG objects.
 *
 * @function SVGService
 * @returns {object} Various public interface methods
 */
const SVGService = (function() {
    let loadedSVGs = {};
    const svgNS = "http://www.w3.org/2000/svg";

    // *** Public interface ***//


// mock of mapmeta.... https://wayfinding-task-service.dev.ad.l11.com/wayfinding/v1/assets/metadata
//[{"tp":"MapMetadata","id":"0341a47a-b87b-4fcd-b4c4-b2cce43a5355","__etag":"-1","assetRef":"f02b958c-af27-471a-b738-85f71700ee0b","url":"url","structure":"AmericanDream","level":3,"desc":"Map of floor 3","markerScale":1.0,"autoZoomMargin":1.0,"positionGeoUpper":{"x":6,"y":210,"z":14}},{"tp":"MapMetadata","id":"d3565e64-8d25-4861-a66b-a5010ea934be","__etag":"-1","assetRef":"f606ec1c-8b9e-4aca-a4c0-dd8cb0167444","url":"url","structure":"AmericanDream","level":2,"desc":"Map of floor 2","markerScale":1.0,"autoZoomMargin":1.0,"positionGeoUpper":{"x":6,"y":210,"z":14}},{"tp":"MapMetadata","id":"b3fbe0fa-af0b-4b32-b538-e662c28721c4","__etag":"-1","assetRef":"2322ba94-275f-449c-88e3-e70c1e8cfd83","url":"url","structure":"AmericanDream","level":1,"desc":"Map of floor 1","markerScale":1.0,"autoZoomMargin":1.0,"positionGeoUpper":{"x":6,"y":210,"z":14}}]

// mock of map level1: https://wayfinding-task-service.dev.ad.l11.com/wayfinding/v1/assets/search?structure=AmericanDream&level=1
// see mockmap1.svg

// mock of map level2: https://wayfinding-task-service.dev.ad.l11.com/wayfinding/v1/assets/search?structure=AmericanDream&level=2
// see mockmap2.svg

// mock of map level3: https://wayfinding-task-service.dev.ad.l11.com/wayfinding/v1/assets/search?structure=AmericanDream&level=3
// see mockmap3.svg


    return {
        loadSVGDataByName: function (name, callback) {
            loadSVGData(name, callback);
        },
        loadMockSVGDataByName: function (name, callback) {
            loadMockSVGData(name, callback);
        },
        getSVGDataByName: function (name) {
            return loadedSVGs[name].documentElement;
        },
        getSVGCloneByName: function (name) {
            if (Object.keys(loadedSVGs).length > 0) {
                return loadedSVGs[name].documentElement.cloneNode(true);
            } else {
                return null;
            }

            // if ( loadedSVGs[getSVGById(name)] ) {
            //   return loadedSVGs[getSVGById(name)].documentElement.cloneNode(true);
            // } else {
            //   return null;
            // }
        },
        getSVGViewport: function (svg) {
            return getSVGViewport(svg);
        },
        getSVGLevelsOfDetail: function (svg) {
            return findSVGLevelsOfDetail(svg);
        },
        getSVGVisualElements: function (svg) {
            return findSVGVisualElements(svg);
        },
        getSVGPointsOfInterest: function (svg) {
            return findSVGPointsOfInterest(svg);
        },
        getLoadedSVGNames: function () {
            let SVGNames = [];
            Object.entries(loadedSVGs).forEach(([key, val]) => {
                SVGNames.push(key);
            });
            return SVGNames;
        },
        getSVGNS: function () {
            return svgNS;
        },
        drawSVGViewBox: function(svg) {
            drawSVGViewBox(svg);
        },
        drawRouteOnSVG: function (svg, route) {
            drawRouteOnSVG(svg, route);
        },
        drawLocatableOnSVG: function (svg, position, className, id, style, onClick, label) {
            drawLocatableOnSVG(svg, position, className, id, style, onClick, label);
        }
    }

    // *** Private methods ***//

    /**
     * Fetches SVG data for the given map and parses it into a SVGDocument for parsing
     *
     * @param {string} name The name of the map being loaded.... changed to mapMeta... name was lame! this gives us a lot more.
     * @param {function} [callback=null] An optional callback function for after the SVG is loaded
     */
    function loadSVGData (mapMeta, callback = null) {


        APIService.GetMapSVG(mapMeta)
            .then(svg => {
                const name = mapMeta.id;

                namespaceStyles(svg, name);
                svg.documentElement.setAttribute("name", name);
                loadedSVGs[name] = svg;

                if (callback) {
                    callback(svg);
                }
            });
    }


    function loadMockSVGData (mapMeta, callback = null) {

          APIService.GetMockMapSVG(mapMeta)
              .then(svg => {
                  const name = mapMeta.id;

                  namespaceStyles(svg, name);
                  svg.documentElement.setAttribute("name", name);
                  loadedSVGs[name] = svg;

                  if (callback) {
                      callback(svg);
                  }
              });

    }

    // function getSVGById (name) {
    //   Object.keys(obj).length
    //     for ( var idx = 0; idx < Object.keys(loadedSVGs).length; idx++ ) {
    //       if ( loadedSVGs[idx].id === name ) {
    //         return idx;
    //       }
    //     }
    //     return 0;
    // }

    /**
     * Provides namespacing for each SVG's styles
     * Parses the loaded SVG for a <style> block and updates the class names with the SVG's name
     * Parses the loaded SVG for class names and updates them with the SVG's name
     *
     * @param {SVGDocument} svg The SVG to apply namespacing
     * @param {string} namespace The namespace to apply
     */
    function namespaceStyles (svg, namespace) {
        // Remove period from namespace
        //namespace = namespace.replace(/\./g, "");

        // Looks for all ".st" strings in the style block's string and inserts the namespace

        // TODO: JJR NOTE: this was working for Level11 Map, but not AD map.
        // Try to hunt down what was the reasoning behind this to not lose the value, but
        // currently its working better without it.

        // const styleBlock = svg.querySelectorAll('style')[0];
        // if (styleBlock) {
        //   styleBlock.innerHTML = svg.querySelectorAll('style')[0].innerHTML.replace(/\.st/g, namespace.id + '-st');
        // }
        //
        // // Replaces all "st" starting class-styled elements and inserts the namespace
        // const styledElements = svg.querySelectorAll('[class^=st]');
        // (styledElements).forEach(element => {
        //     element.setAttribute('class', element.getAttribute('class').replace(/st/g, namespace.id + '-st'));
        // });
    }

    /**
     * Parses the given SVG for LoD groups
     *
     * @param {SVGDocument} svg The SVG document to parse for LoD groups
     * @returns {NodeList} A DOM NodeList object
     */
    function findSVGLevelsOfDetail (svg) {
        return svg.querySelectorAll('g[id*="LoD"]');
    }

     /**
     * Parses the given SVG for rect elements
     *
     * @param {SVGDocument} svg The SVG to parse for visual elements
     * @returns {NodeList} A DOM NodeList object
     */
    function findSVGVisualElements (svg) {
        return svg.querySelectorAll('rect, circle, polygon, path, polyline');
    }

    /**
     * Parses the given SVG for Points of Interest
     *
     * @param {SVGDocument} svg The SVG to parse for Points of Interest
     * @returns {NodeList} A DOM NodeList object
     */
    function findSVGPointsOfInterest (svg) {
        return svg.querySelectorAll('[id]');
    }

    /**
     * Draws a route line on the given SVG (after removing any existing route line)
     *
     * @param {SVGDocument} svg The SVG to draw a route line on
     * @param {Route} route The route object to draw
     * @returns Nothing
     */
    function drawRouteOnSVG (svg, route) {
        const svgName = svg.getAttribute("name");
        const viewport = getSVGViewport(svg);
        if (!viewport) throw new Error("SVGService::drawRouteOnSVG : No viewport is available.");
        if (route === null) throw new Error("SVGService::drawRouteOnSVG : Route provided is null");

        // Clear our previous route line
        const previousRouteLine = getExistingRouteLineInSVG(svg);
        if(previousRouteLine) {
            viewport.removeChild(previousRouteLine);
        }

        let routePoints = "";
        route.route.forEach(routeNode => {
            if (routeNode.waypoint.map === svgName) {
                routePoints += routeNode.waypoint.position.X + "," + routeNode.waypoint.position.Y + " ";
            }
        });

        let routeLine = document.createElementNS(SVGService.getSVGNS(),"polyline");
        routeLine.setAttribute("points", routePoints);
        routeLine.setAttribute("class", "route-line");
        routeLine.setAttribute("id", "route-line");

        viewport.appendChild(routeLine);
    }

    /**
     * Finds any existing route lines in a given SVG
     *
     * @param {SVGDocument} svg The SVG to search for route lines
     * @returns {SVGElement} The SVG element for a route line
     */
    function getExistingRouteLineInSVG (svg) {
        return svg.getElementById("route-line");
    }

    /**
     * Finds the SVG viewport for a given SVG as generated by SVGPanZoom, or the base SVG viewport
     *
     * @param {SVGDocument} svg The SVG to search for a viewport
     * @returns {SVGElement} The SVG element for the viewport
     */
    function getSVGViewport (svg) {
        if (!svg) throw new Error("SVGService::getSVGViewport : Null SVG provided.");
        let viewportSearch = svg.getElementsByClassName("svg-pan-zoom_viewport");
        if (viewportSearch.length === 1) {
            return viewportSearch[0];
        } else {
            return svg;
        }
    }

    /**
     * Draws a located item group and circle on the given SVG,
     * or updates the position of a located item,
     * or removes previous items if no position is provided.
     * If a label is provided, that label is added to the group.

     :0-|-< JJR Updates: this is close to what we want but not really the designed behavior...so going to have to update...hopefully in a non-destructive way
     *
     * @param {SVGDocument} svg The SVG to draw a located item on
     * @param {Position} locatablePosition The Position of the located item to draw.  If null, this function will simply remove the item;
     * @param {string} id An optional ID to append to the item element, enabling multiple item drawings keyed on ID
     * @returns Nothing
     */
    function drawLocatableOnSVG (svg, locatablePosition, className = "", id = "", style = "", onClick, label) {

        const viewport = getSVGViewport(svg);
        if (!viewport) throw new Error("SVGService::drawLocatableOnSVG : No viewport is available.");
        if (id === "") console.warn("SVGService::drawLocatableOnSVG : No ID provided for drawn item - likely to cause naming collisions!");
          // JJR thinks: I think this is broken becuase id is now being used in an entirely different way
        const previousLocatableGroup = svg.getElementById(id);
        if (previousLocatableGroup !== null && locatablePosition !== null) {
            // Update existing item position
            previousLocatableGroup.setAttribute("transform", `translate(${locatablePosition.X},${locatablePosition.Y})`);
        }
        else if (locatablePosition !== null) {
            // No existing item, create new
            // TODO: Support other shapes
            let locatableGroup = document.createElementNS(SVGService.getSVGNS(), "g");
            locatableGroup.setAttribute("transform", `translate(${locatablePosition.X},${locatablePosition.Y})`);
            locatableGroup.setAttribute("id", id);

            let locatableElement = document.createElementNS(SVGService.getSVGNS(), "polygon");
            locatableElement.setAttribute("class", "locatable " + className);
            locatableElement.setAttributeNS(null, 'points', '-30,-20 -30,-490 450,-490');
            // Give each locatable a random color in addition to its optional style overrides
            locatableElement.setAttribute("style", `fill: ${"#"+((1<<24)*Math.random()|0).toString(16)}; ` + style);
            if (onClick !== null && typeof onClick === "function") {
                locatableElement.addEventListener("click", onClick);
            }

            locatableGroup.appendChild( locatableElement );
            // Draw ID label if available
            if (label) {
                let locatableLabel = document.createElementNS(SVGService.getSVGNS(), "text");
                locatableLabel.textContent = label;
                locatableLabel.setAttribute("class", "locatable-label");
                locatableLabel.setAttributeNS(null, 'x', 0);
                locatableLabel.setAttributeNS(null, 'stroke-width', 0);
                locatableLabel.setAttributeNS(null, 'y', -450);
                locatableLabel.setAttribute("style", `font: bold 30px sans-serif;`);
                locatableGroup.appendChild( locatableLabel );
            }
            viewport.appendChild( locatableGroup );
        }
        else {
            // Clear our previous item
            if(previousLocatableGroup) {
                // JJR HACK ...commented out to see how it goes...
                //viewport.removeChild(previousLocatableGroup);
                //const randcolor = '#'+Math.floor(Math.random()*16777215).toString(16);
                //const randcolor = 'rgba('+Math.floor(Math.random()*100+155)+','+Math.floor(Math.random()*100+155)+','+Math.floor(Math.random()*100+155)+',1)';

                // var parisColors = ["252,206,4",  // way to get random colors but under control. ParisColors didn't particularly work.
                //                 "13,77,156",
                //                 "139,134, 20",
                //                 "148,214, 205",
                //                 "185,38, 145",
                //                 "252,122, 44",
                //                 "116,198, 122",
                //                 "232,126, 164",
                //                 "205,151, 203",
                //                 "195,201, 13",
                //                 "209,161, 25",
                //                 "116,62,12",
                //                 "39,130, 89",
                //                 "77,3,125"];


                  var proColors =  [
                                // "#FAC856",
                                // "#EBCA65",
                                // "#DBCC75",
                                // "#CCCE84",
                                // "#BDD093",
                                // "#ADD2A3",
                                // "#9ED5B2",
                                // "#8ED7C2",
                                // "#7FD9D1",
                                // "#70DBE0",
                                // "#60DDF0",
                                // "#51DFFF",

                                // "#fac856",
                                // "#fed174",
                                // "#ffda90",
                                // "#ffe3ac",
                                // "#ffecc7",
                                // "#fff5e3",

                                // "#ffffff",
                                // "#fac856",
                                // "#cca348",
                                // "#a0803b",
                                // "#765f2e",
                                // "#4e3f21",
                                // "#2a2215",

                                // "#ddae3c",
                                // "#ebbb49",
                                // "#fac856",
                                // "#ffd563",
                                // "#ffe370",
                                // "#fff17d"
                              //  "#222222",
                                //"#333333",
                                //"#999999",
                                "#BBBBBB",

                              ];

               previousLocatableGroup.setAttribute("style", "fill: " + proColors[Math.floor(Math.random()*1)]);
            }
        }
    }

    /**
     * Draws the viewbox in a given SVG
     *
     * @param {SVGDocument} svg
     */
    function drawSVGViewBox (svg) {
        const viewport = getSVGViewport(svg);
        if (!viewport) throw new Error("SVGService::drawSVGViewBox : No viewport is available.");

        const viewbox = svg.getAttribute("viewBox"),
              width = viewbox.split(" ")[2],
              height = viewbox.split(" ")[3];

        var rect = document.createElementNS(svgNS, 'rect');
        rect.setAttributeNS(null, 'x', 0);
        rect.setAttributeNS(null, 'y', 0);
        rect.setAttributeNS(null, 'height', height);
        rect.setAttributeNS(null, 'width', width);
        rect.setAttributeNS(null, 'class', 'map-viewbox');
        rect.setAttributeNS(null, 'id', 'map-viewbox-' + svg.getAttribute('name'));
        viewport.insertBefore(rect, viewport.children[0]);
    }

    // /**
    //  * Draws POIs on the given SVG (after removing any existing POIs)
    //  *
    //  * @param {SVGDocument} svg The SVG to draw POIs on
    //  * @param {Array<POI>} POIs The POIs to draw
    //  * @param {function} onClick Optional onClick function for the POIs with parameters (event, clicked POI)
    //  */
    // function drawPOIsOnSVG (svg, POIs, onClick = null) {
    //     if (POIs === null) throw new Error("SVGService::drawPOIsOnSVG : POIs provided is null");

    //     // Clear our previous POIs
    //     const previousPOIs = getExistingPOIsInSVG(svg);
    //     for (var i = 0; i < previousPOIs.length; i++) {
    //         viewport.removeChild(previousPOIs[i]);
    //     }

    //     for (var p = 0; p < POIs.length; p++) {
    //         const POI = POIs[p];

    //         // Set the POI element to the one on the given map
    //         POI.element = svg.getElementById(POI.id);

    //         let POIMarker = document.createElementNS(SVGService.getSVGNS(),"circle");
    //         POIMarker.setAttribute("class", "point-of-interest");
    //         // Set POI position to center of POI element bounding box
    //         // TODO: Account for custom POI marker positioning
    //         POIMarker.setAttribute("cx", POI.centerPosition.X);
    //         POIMarker.setAttribute("cy", POI.centerPosition.Y);
    //         if (onClick !== null) {
    //             POIMarker.addEventListener("click", (ev) => onClick(ev, POI));
    //         }

    //         viewport.appendChild(POIMarker);
    //     }
    // }
})();

export default SVGService;



// WEBPACK FOOTER //
// ./src/services/SVG.js